import { render, staticRenderFns } from "./tritonix.vue?vue&type=template&id=e993b55a&scoped=true&"
import script from "./tritonix.vue?vue&type=script&lang=js&"
export * from "./tritonix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e993b55a",
  null
  
)

export default component.exports